// domain / caso de uso

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

// typings
import {
  IAtualizarClientePayload,
  ICreateClienteResponse,
} from "@/hooks/usuários/atualizar-cliente/index.d";

// store / zustand
import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

import { handleAtualizarUsuario } from "@/domain/use-cases/cutomers";

// toast helper
const notifySuccess = (message: string) =>
  toast(message, {
    type: "success",
    position: "top-center",
  });

const notifyError = (message: string) =>
  toast(message, {
    type: "error",
    position: "top-center",
  });

// novo tipo de input
type IDataApi = {
  user_id: number;
  payload: IAtualizarClientePayload;
};

export function useAtualizarUsuario() {
  const queryClient = useQueryClient();
  const { token } = useStoreZustandUserAuth();

  const mutation = useMutation<
    ICreateClienteResponse, // retorno
    Error, // erro
    IDataApi // entrada
  >({
    mutationFn: async ({ user_id, payload }: IDataApi) => {
      return await handleAtualizarUsuario(token!, user_id, payload);
    },
    onSuccess: async (data) => {
      if (!data.success) {
        notifyError("Houve um error em atualizar usuário!");
        return;
      }
      notifySuccess("Usuário atualizado com sucesso!");
      await queryClient.invalidateQueries({ queryKey: ["um-usuario"] });
    },
    onError: async () => {
      notifyError("Houve um error em atualizar usuário!");
    },
  });

  return {
    atualizarUsuario: mutation.mutate,
    atualizarUsuarioAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    isSuccess: mutation.isSuccess,
  };
}
